// extracted by mini-css-extract-plugin
export var formContainer = "_ki-0";
export var message = "_ki-1";